import { render, staticRenderFns } from "./AddNewAccount.vue?vue&type=template&id=3492016e&scoped=true&"
import script from "./AddNewAccount.vue?vue&type=script&lang=js&"
export * from "./AddNewAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAccount.vue?vue&type=style&index=0&id=3492016e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492016e",
  null
  
)

export default component.exports